import React from 'react';
import PropTypes from "prop-types";
import { DateFormat, dateFromState, dateToState, getHumanReadableDate } from "../../../Helpers/DateTimeHelper";
import { addDays, isBefore, subDays } from "date-fns";
import DatePickerButtonInput from "../DatePickerButtonInput";

const AvailabilityDateSelector = (props) => {

    const isBackButtonDisabled = () => {
        const today = new Date();

        return isBefore(
            dateFromState(props.bookingDate),
            today
        );
    }

    const handlePreviousDayClick = () => {
        let date = dateFromState(props.bookingDate);
        date = subDays(date, 1)
        props.onBookingDateChange(dateToState(date));
    }

    const handleNextDayClick = () => {
        let date = dateFromState(props.bookingDate);
        date = addDays(date, 1);
        props.onBookingDateChange(dateToState(date));
    }

    return (
        <div className={`display-inline-block ${props.className}`}>
            <div
                className="display-inline-block"
                style={{width: '12rem'}}
            >
                <button className="button secondary clear margin-0"
                    style={{padding: '0.3rem'}}
                    onClick={(e) => handlePreviousDayClick()}
                    disabled={isBackButtonDisabled()}
                >
                    <i className="fa fa-chevron-left"></i>
                </button>

                <span className="padding-left-1 padding-right-1 text-bold">
                    {getHumanReadableDate(props.bookingDate, DateFormat.HUMAN_SLASHED_DATE_WITH_WEEKDAY_ABBREVIATED)}
                </span>

                <button className="button secondary clear margin-0"
                    style={{padding: '0.3rem'}}
                    onClick={(e) => handleNextDayClick()}
                >
                    <i className="fa fa-chevron-right"></i>
                </button>
            </div>

            <div className="display-inline-block margin-left-2"
                style={{
                    width: '2rem'
                }}
            >
                <DatePickerButtonInput
                    date={props.bookingDate}
                    onChange={props.onBookingDateChange}
                />
            </div>
        </div>
    );
};

AvailabilityDateSelector.propTypes = {
    className: PropTypes.string,
    bookingDate: PropTypes.string.isRequired,
    onBookingDateChange: PropTypes.func.isRequired,
};

AvailabilityDateSelector.defaultProps = {
    className: '',
};

export default AvailabilityDateSelector;
